import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { CommonService } from '../../../../shared/services/common.service'
import {
  CmsService,
  AuthService,
  User,
  GlobalMessageType,
  GlobalMessageService,
} from '@spartacus/core'
import { switchMap, take } from 'rxjs/operators'
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms'
import { of, Observable } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { UserAccountFacade } from '@spartacus/user/account/root'
@Component({
  standalone: false,
  selector: 'vs-customer-account',
  templateUrl: './customer-account.component.html',
  styleUrls: ['./customer-account.component.scss'],
})
export class CustomerAccountComponent implements OnInit, OnDestroy {
  user$: Observable<User>
  public userTypes
  public showSuccess = false
  userTypes$: Observable<any>
  myprofile: FormGroup
  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  addresses: any
  decimalvalue: any
  accountvalue: any
  customerObj: { comments: any }
  bunit: any
  @ViewChild('infoMsg', { static: false }) infoMsg: ElementRef
  @ViewChild('successMsg', { static: false }) successMsg: ElementRef
  bhBusinessUID: any
  custAccountUID: any

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private auth: AuthService,

    private globalMessageService: GlobalMessageService,
    private activatedRoute: ActivatedRoute,
    private userAccountFacade: UserAccountFacade
  ) {}
  get formControls() {
    return this.myprofile.controls
  }
  get custaccount() {
    return this.myprofile.get('custaccount')
  }
  get bhbusiness() {
    return this.myprofile.get('bhbusiness')
  }
  get shipaddress() {
    return this.myprofile.get('shipaddress')
  }
  get decimalformat() {
    return this.myprofile.get('decimalformat')
  }
  getCustomerDetails() {
    const params = ['users', 'current', 'customerdetails']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { fields: 'FULL' }
    this.userTypes$ = this.commonService.getData_WithoutRetry(apiUrl, apiParams)
    this.commonService.getData_WithoutRetry(apiUrl, apiParams).subscribe(
      (success: any) => {
        success.b2bUnits.forEach((unit) => {
          if (unit?.isDefaultB2bUnit) {
            this.userTypes = unit
          }
        })
        // this.addresses = this.userTypes?.b2bUnits[0].addresses;
        this.bunit = this.userTypes.vsSalesArea
        this.decimalvalue = this.userTypes.decimalFormatPreference
        this.accountvalue = this.userTypes
        // this.myprofile.controls.shipaddress.setValue(
        //   this.addresses[0]?.formattedAddress
        // );
        // this.addresses.forEach((element) => {
        //   if (element?.defaultAddress) {

        //     this.myprofile.controls.shipaddress.setValue(
        //       element?.id
        //     );
        //   }
        // });
        this.decimalvalue.forEach((decimal, index) => {
          if (decimal.isDefault == true) {
            this.myprofile.controls['decimalformat'].setValue(decimal?.value)
            return
          } else if (index == 0) {
            this.myprofile.controls['decimalformat'].setValue(decimal?.value)
          }
        })
        this.commonService.getUserData().subscribe(
          (data) => {
            if (
              data['orgUnit'].name !== undefined &&
              data['orgUnit'].name !== null
            ) {
              this.myprofile.controls['custaccount'].setValue(
                data['orgUnit'].name
              )
              this.custAccountUID = data['orgUnit'].uid
            }
            if (
              data['recentSalesArea'].salesOrganization !== undefined &&
              data['recentSalesArea'].salesOrganization !== null
            ) {
              this.myprofile.controls['bhbusiness'].setValue(
                data['recentSalesArea'].salesOrganization
              )
              this.bhBusinessUID = data['recentSalesArea'].uid
            }
            this.getAddressDetails(data)
          },
          (err) => {}
        )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  goToTop() {
    window.scrollTo(0, 0)
  }

  getAddressDetails(currentData) {
    const params = ['users', 'current', 'shippingAddresses']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = {
      customerAccountId: currentData?.orgUnit?.uid,
      legalEntityId: currentData?.recentSalesArea.uid,
    }

    this.commonService.getData(apiUrl, apiParams).subscribe((response) => {
      this.addresses = response['addresses']
      this.myprofile.controls['shipaddress'].setValue(this.addresses[0]?.id)

      this.addresses.forEach((element) => {
        if (element?.defaultAddress) {
          this.myprofile.controls['shipaddress'].setValue(element?.id)
        }
      })
    })
  }

  postCustDataChange() {
    const params = ['users', 'current', 'customerdetails']
    const apiUrl = this.commonService.constructUrl(params)
    let customerObj = {
      defaultB2bUnitUid: this.custAccountUID, //this.myprofile.value.custaccount,
      defaultAddressId: this.myprofile.value.shipaddress,
      defaultVsSalesAreaUid: this.bhBusinessUID, //this.myprofile.value.bhbusiness,
      defaultDecimalPreference: this.myprofile.value.decimalformat,
    }
    this.commonService.postData(apiUrl, customerObj).subscribe(
      (success) => {
        // this.showSuccess = true;
        // this.successMsg.nativeElement.style.display = 'block';
        this.globalMessageService.add(
          { key: 'myProfile.profileUpdated' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          180000
        )
        this.goToTop()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  getCustData() {}
  clearCustomerDetail() {
    this.myprofile.reset()
    this.getCustomerDetails()
  }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (success) => {},
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.user$ = this.auth.isUserLoggedIn().pipe(
      take(1),
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.getCustomerDetails()
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    // this.getUId()
    this.user$.subscribe(
      (success) => {},
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.myprofile = this.formBuilder.group({
      custaccount: new FormControl({ value: '', disabled: true }),
      bhbusiness: new FormControl({ value: '', disabled: true }),
      shipaddress: new FormControl(''),
      decimalformat: new FormControl(''),
    })
  }
  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
  }
}
